import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatIconModule } from '@angular/material/icon';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'formly-repeat-read-section',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MatIconModule,
        FormlyModule,
        FormlyMaterialModule,
    ],
    template: `

    <div class="w-full">
    <div *ngIf="field.fieldGroup && field.fieldGroup.length>0;else empty_content">
     <span *ngIf="props.label"  class="font-semibold underline ml-2 underline-offset-2">{{ props.label }}</span>
      <div class="mt-2" *ngFor="let field of field.fieldGroup; let i = index">
        <formly-field  [field]="field"></formly-field>
      </div>
    </div>
    <ng-template #empty_content>
      <span class="font-semibold ml-2 mb-6 ">{{props.label}} - NESSUN ELEMENTO</span>
    </ng-template>
    </div>
    `,
})
export class RepeatReadTypeComponent extends FieldArrayType {}
